module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0149.jpg?v=88a61f21";